import styled from 'styled-components';
import { getThemeByPath } from '~/utils';

const giantSpacing = getThemeByPath('spacings.giant');
const mediumSpacing = getThemeByPath('spacings.medium');

const bkpTablet = getThemeByPath('breakpoints.tablet');

export const Wrapper = styled.div`
  padding: 0 ${giantSpacing}px;

  @media (max-width: ${bkpTablet}px) {
    padding: 0 ${mediumSpacing}px;
  }
`;
